import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Impressum() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <img src="/images/logo.svg" alt="Logo" className="legal-logo" />
        <h1>Schulungsplattform</h1>
      </div>
      <div className="legal-content">
        <h2>Impressum</h2>
        <div className="legal-section">
          <h3>Angaben gemäß § 5 TMG</h3>
          <p><strong>F&F AI Automation Services & Products UG (haftungsbeschränkt)</strong></p>
        </div>
        <div className="legal-section">
          <h3>Ladungsfähige Geschäftsadresse</h3>
          <p>Wannenstr. 14<br />74842 Billigheim, Baden-Württemberg<br />Deutschland</p>
        </div>
        <div className="legal-section">
          <h3>Vertretungsberechtigte Personen</h3>
          <p>Robin Fichter, Gesellschafter und Geschäftsführer<br />Gabriel Frank, Gesellschafter</p>
        </div>
        <div className="legal-section">
          <h3>Kontakt</h3>
          <p>E-Mail: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a><br />
          Website: <a href="https://www.ff-ai-automation.de" target="_blank" rel="noreferrer">www.ff-ai-automation.de</a></p>
        </div>
        <div className="legal-section">
          <h3>Registereintrag</h3>
          <p>Registergericht: Amtsgericht Mannheim<br />Registernummer: HRB 757313</p>
        </div>
        <div className="legal-section">
          <h3>Umsatzsteuer-Identifikationsnummer</h3>
          <p>DE460275116</p>
        </div>
        <p className="legal-copy">© {new Date().getFullYear()} F&F AI Automation Services & Products UG</p>
      </div>
    </div>
  );
}
